import request from '@/utils/request'


// 登录
export function login(username, password) {
  return request({
    url: '/admin/auth/login',
    method: 'post',
    data: {
      username,
      password
    }
  })
}

export function getInfo() {
  return request({
    url: '/admin/auth/info',
    method: 'get',
  })
}

export function logout() {
  return request({
    url: '/admin/auth/logout',
    method: 'post'
  })
}

export function updatePassword(params) {
  return request({
    url: '/admin/auth/update/password',
    method: 'post',
    data: params
  })
}

export function fetchList(params) {
  return request({
    url: '/admin/admin/list',
    method: 'get',
    params: params
  })
}

export function createAdmin(data) {
  return request({
    url: '/admin/admin/add',
    method: 'post',
    data: data
  })
}

export function updateAdmin(id, data) {
  return request({
    url: '/admin/admin/update/' + id,
    method: 'post',
    data: data
  })
}

export function updateStatus(id, state) {
  return request({
    url: '/admin/admin/update/' + id+'/'+state,
    method: 'post',
  })
}

export function deleteAdmin(id) {
  return request({
    url: '/admin/admin/remove/' + id,
    method: 'post'
  })
}

export function getRoleByAdmin(id) {
  return request({
    url: `/admin/admin/${id}/roleList`,
    method: 'get'
  })
}

export function allocRole(data) {
  return request({
    url: `/admin/admin/setRoles/${data.id}/${data.ids}`,
    method: 'post',
    data: data
  })
}
export function getMenuTwoList() {
  return request({
    url: `/admin/menu/2/list`,
    method: 'get'
  })
}


// WEBPACK FOOTER //
// ./src/api/login.js